export const AUTOMATIC_ORDERING_DISABLED = 'AUTOMATIC_ORDERING_DISABLED';
export const AUTOMATIC_ORDERING_ENABLED = 'AUTOMATIC_ORDERING_ENABLED';

export const COPY_FORMULA_PROACTIVE = 'PROACTIVE';
export const COPY_FORMULA_STANDARD = 'STANDARD';
export const COPY_FORMULA_CUSTOM = 'CUSTOM';

export const COPY_FORMULA_OBJECT_PROACTIVE = { key: COPY_FORMULA_PROACTIVE, value: 'Proactive' };
export const COPY_FORMULA_OBJECT_STANDARD = { key: COPY_FORMULA_STANDARD, value: 'Standard' };
export const COPY_FORMULA_OBJECT_CUSTOM = { key: COPY_FORMULA_CUSTOM, value: 'Custom' };

export const GENERATION_INTERVAL_NEVER = 'NEVER';
export const GENERATION_INTERVAL_DAILY = 'DAILY';
export const GENERATION_INTERVAL_WEEKLY = 'WEEKLY';
export const GENERATION_INTERVAL_FORTNIGHTLY = 'FORTNIGHTLY';
export const GENERATION_INTERVAL_MONTHLY = 'MONTHLY';
export const GENERATION_INTERVAL_QUARTERLY = 'QUARTERLY';

export const MAX_COPIES_UNLIMITED_KEY = 'Unlimited';
export const MAX_COPIES_UNLIMITED_VALUE = null;

export const RESERVE_GROUPBY_ALL = 'ALL';

export const RESERVE_STATUS_OPEN = 'OPEN';
export const RESERVE_STATUS_NEW = 'NEW';
export const RESERVE_STATUS_CLOSED = 'CLOSED';
export const RESERVE_STATUS_PROCESSING = 'PROCESSING';
export const RESERVE_STATUS_CANCELLED = 'CANCELLED';
export const RESERVE_STATUS_COMPLETE = 'COMPLETE';
export const RESERVE_STATUS_ORDERED = 'ORDERED';

export const RESERVE_ACCEPT_ACTION_VALUE = 'accept';
export const RESERVE_REJECT_ACTION_VALUE = 'reject';

export const AUTOMATIC_ORDERING_STATE = {
    [AUTOMATIC_ORDERING_ENABLED]: 'yes',
    [AUTOMATIC_ORDERING_DISABLED]: 'no'
};

const NON_CUSTOM_COPY_FORMULAS = {
    [COPY_FORMULA_STANDARD]: COPY_FORMULA_OBJECT_STANDARD,
    [COPY_FORMULA_PROACTIVE]: COPY_FORMULA_OBJECT_PROACTIVE
};

const ALL_COPY_FORMULAS = {
    ...NON_CUSTOM_COPY_FORMULAS,
    [COPY_FORMULA_CUSTOM]: COPY_FORMULA_OBJECT_CUSTOM
};

export function getCopyFormulas(
    isCustomEnabled: boolean
): ReadonlyArray<{ readonly key: string; readonly value: string }> {
    if (!isCustomEnabled) {
        return Object.values(NON_CUSTOM_COPY_FORMULAS);
    }

    return Object.values(ALL_COPY_FORMULAS);
}

export function mapCopyFormula(
    key: typeof COPY_FORMULA_STANDARD | typeof COPY_FORMULA_PROACTIVE | typeof COPY_FORMULA_CUSTOM | undefined
) {
    if (!key) {
        return undefined;
    }

    return ALL_COPY_FORMULAS[key];
}

export const GENERATION_INTERVAL = {
    [GENERATION_INTERVAL_NEVER]: 'noAutomaticGeneration',
    [GENERATION_INTERVAL_DAILY]: 'daily',
    [GENERATION_INTERVAL_WEEKLY]: 'weekly',
    [GENERATION_INTERVAL_FORTNIGHTLY]: 'fortnightly',
    [GENERATION_INTERVAL_MONTHLY]: 'monthly',
    [GENERATION_INTERVAL_QUARTERLY]: 'quarterly'
};

export type ReserveGroupByKey =
    | typeof RESERVE_GROUPBY_ALL
    | typeof RESERVE_STATUS_NEW
    | typeof RESERVE_STATUS_OPEN
    | typeof RESERVE_STATUS_CLOSED
    | typeof RESERVE_STATUS_PROCESSING
    | typeof RESERVE_STATUS_COMPLETE
    | typeof RESERVE_STATUS_CANCELLED;

const RESERVE_GROUP_BY_OPTIONS = {
    [RESERVE_GROUPBY_ALL]: 'all',
    [RESERVE_STATUS_NEW]: 'new',
    [RESERVE_STATUS_OPEN]: 'open',
    [RESERVE_STATUS_CLOSED]: 'closed',
    [RESERVE_STATUS_PROCESSING]: 'processing',
    [RESERVE_STATUS_COMPLETE]: 'complete',
    [RESERVE_STATUS_CANCELLED]: 'cancelled'
};

export function getReserveGroupByOptions(): ReadonlyArray<{ readonly key: ReserveGroupByKey; readonly label: string }> {
    return Object.entries(RESERVE_GROUP_BY_OPTIONS).map(([key, label]) => ({ key: key as ReserveGroupByKey, label }));
}

export function isReserveGroupByOption(groupByKey: ReserveGroupByKey): boolean {
    return !!RESERVE_GROUP_BY_OPTIONS[groupByKey];
}

type ReserveRatio = {
    readonly key: number;
    readonly value: string;
};

export function generateReserveRatios(maxRatio: number = 100): ReadonlyArray<ReserveRatio> {
    const ratios: Array<ReserveRatio> = [];
    for (let i = 1; i <= maxRatio; i++) {
        ratios.push({
            key: i,
            value: `${i}`
        });
    }
    return ratios;
}

export function mapReserveRatio(key: number, ratios: ReadonlyArray<ReserveRatio>): string {
    for (const ratio of ratios) {
        if (ratio.key === key) {
            return ratio.value;
        }
    }
    return '';
}

export function mapMaxCopiesValueToKey(
    maxCopyValue: number | typeof MAX_COPIES_UNLIMITED_VALUE | typeof MAX_COPIES_UNLIMITED_KEY | undefined
) {
    if (maxCopyValue === MAX_COPIES_UNLIMITED_KEY || maxCopyValue === MAX_COPIES_UNLIMITED_VALUE) {
        return MAX_COPIES_UNLIMITED_KEY;
    }

    return maxCopyValue;
}

export function generateMaxCopies(maxCopiesCount = 250): ReadonlyArray<number | typeof MAX_COPIES_UNLIMITED_KEY> {
    const maxCopiesArr: Array<number | typeof MAX_COPIES_UNLIMITED_KEY> = [];
    for (let i = 1; i <= maxCopiesCount; i++) {
        maxCopiesArr.push(i);
    }
    maxCopiesArr.push(MAX_COPIES_UNLIMITED_KEY);
    return maxCopiesArr;
}
